import { gql } from '@/__generated__';

const RESTORE_USER = gql(`#graphql
  mutation RestoreUser($input: RestoreUserInput!) {
    restoreUser(input: $input) {
      userId
    }
  }
`);

export default RESTORE_USER;
